<template>
  <v-container>
    <v-row justify="center">
      <v-col md="8">
        <v-img
          src="/img/HealthViewCapital-ColorLogo.png"
          alt="HealthView Capital Partners Logo"
          height="165"
          contain
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'BannerLogo',
}
</script>
